import React, { useEffect, useState } from 'react';
import { Fab, makeStyles } from '@material-ui/core';
import { NavigationIcon } from '@dev/ee-components';
import clsx from 'clsx';

const useStyles = makeStyles({
    fab: {
        transition: 'opacity 1s ease-in-out',
        opacity: 0,
        position: 'fixed',
        bottom: 48,
        right: '50%',
        pointerEvents: 'none',
        zIndex: 99,
    },
    activeFab: {
        zIndex: 99,
        opacity: 0.3,
        pointerEvents: 'all',
        '&:hover': {
            opacity: 1,
        },
    },
});

export const GoToTopFab = (): JSX.Element => {
    const classes = useStyles();
    const [scrollToTop, setScrollToTop] = useState(false);
    useEffect(() => {
        const onScroll = () => {
            const windowHeight = window.innerHeight;
            const scrollFromTop = window.pageYOffset;
            if (scrollFromTop > windowHeight) {
                return setScrollToTop(true);
            }
            return setScrollToTop(false);
        };
        window.addEventListener('scroll', onScroll);

        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <Fab
            size="small"
            aria-label="toTop"
            variant="extended"
            className={clsx(classes.fab, {
                [classes.activeFab]: scrollToTop,
            })}
            onClick={() =>
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                })
            }
        >
            <NavigationIcon />
        </Fab>
    );
};
